import { UserTypeEnum } from '~/models';
import type { ICreateUserApiPayload, ICreateUserApiResponse } from '../types/SignUp.api';
import type { ISignUpRequest, ISignUpResponse } from '../types/SignUp';

const SOURCE = 'web-portal';

/**
 * One decision point for which referral path a signup takes (GOTU-7435):
 *
 * | flag | referral field           | userType |
 * |------|--------------------------|----------|
 * | off  | `referralID` (legacy id) | absent   |
 * | on   | `referredByCode` (v2)    | `DNT`    |
 *
 * The flag arrives on the request, captured once at the start of the flow, so
 * the two columns can never mix within a submission. With the flag off the
 * payload is byte-for-byte what it was before GOTU-7244.
 */
const toCreateUserPayload = (input: ISignUpRequest): ICreateUserApiPayload => {
  const base = { email: input.email, password: input.password, source: SOURCE };

  if (input.isReferralRebuildEnabled) {
    return {
      ...base,
      userType: UserTypeEnum.DNT,
      ...(input.referredByCode ? { referredByCode: input.referredByCode } : {}),
    };
  }

  return {
    ...base,
    ...(input.referralId ? { referralID: input.referralId } : {}),
  };
};

const toSignUpResponse = (apiResponse: ICreateUserApiResponse): ISignUpResponse => ({
  access_token: apiResponse.accessToken,
  refresh_token: apiResponse.refreshToken,
  expires_in: String(apiResponse.expiresIn),
});

export const SignUpAdapters = {
  toCreateUserPayload,
  toSignUpResponse,
};
